export default __webpack_public_path__ + "static/media/07__o_preview_2.2d715be8.jpg";